import { TreeSelectProps } from "antd";

export const getUpdatedAvatarPositionOnShapeChange = (
  newWidth: number,
  positionX: number,
  oldWidth: number
) => {
  const widthDifference = newWidth - oldWidth;

  const result = positionX - widthDifference / 2;
  return Math.max(0, result);
};

//styles are sent from the BE in Flat Hierarchy:
// {parent: [child_1, child_2, ...],
// child_1 :[child_1_1, child_1_2, ...],
// child_2: [],
// ...}
export const generateGenerationStylesTreeData = (styles?: {
  [key: string]: string[];
}): TreeSelectProps["treeData"] => {
  if (!styles) return [];

  // Collect all items that appear as subcategories in any category
  const allSubcategories = new Set();
  for (const subCategories of Object.values(styles ?? {})) {
    for (const item of subCategories) {
      allSubcategories.add(item);
    }
  }

  // Recursive helper to build tree nodes
  const buildTreeNode = (category: string, isTopLevel = false) => {
    const subCategories = styles[category] || [];
    const hasSubcategories = subCategories.length > 0;

    return {
      key: category,
      title: category,
      value: category,
      // Top-level categories always have selectable: false
      // Nested categories only if they have children
      ...(isTopLevel || hasSubcategories ? { selectable: false } : {}),
      children: subCategories.map((style) => {
        // Check if this style has its own subcategories
        const styleHasChildren = styles[style] && styles[style].length > 0;

        if (styleHasChildren) {
          // Recursively build the subtree
          return buildTreeNode(style, false);
        } else {
          // Leaf node
          return {
            key: style,
            title: style,
            value: style,
          };
        }
      }),
    };
  };

  return Object.keys(styles)
    .filter((category) => !allSubcategories.has(category))
    .map((category) => buildTreeNode(category, true));
};

export const getUpdatedItemPositionOnAddingStroke = (
  strokeWidth: number,
  position: { x: number; y: number },
  size: { width: number; height: number },
  previewWidth: number,
  previewHeight: number
) => {
  const valueRelativeToWidth = strokeWidth / previewWidth;
  const valueRelativeToHeight = strokeWidth / previewHeight;

  const shouldChangePositionXRight = position.x - valueRelativeToWidth < 0;

  const shouldChangePositionXLeft =
    position.x + size.width + valueRelativeToWidth > 1;

  const shouldChangePositionYTop = position.y - valueRelativeToHeight < 0;

  const shouldChangePositionYBottom =
    position.y + size.height + valueRelativeToHeight > 1;

  let x: number;
  let y: number;

  if (shouldChangePositionXRight) {
    x = valueRelativeToWidth;
  } else if (shouldChangePositionXLeft) {
    x = 1 - size.width - valueRelativeToWidth;
  } else {
    x = position.x;
  }

  if (shouldChangePositionYTop) {
    y = valueRelativeToHeight;
  } else if (shouldChangePositionYBottom) {
    y = 1 - size.height - valueRelativeToHeight;
  } else {
    y = position.y;
  }

  return { x, y };
};
